<template>
  <section class="section section-components pb-0" id="about-us">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4">
          <img src="/img/F1hhbjWo_400x400.jpeg" />
        </div>
        <div class="col-lg-8 my-auto">
          <!-- Basic elements -->
          <h2 class="mb-3">
            <span>What is TUHG APES?</span>
          </h2>
          <p class="mb-3">
            There are 5555 Unique Algorithmically generated Thug Apes NFTs.The
            vision of the project is to build up a strong ape community and
            launch ThugApe Gaming which is a play-to-earn function. The Game is
            coming soon. Let’s join us and earn money.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style>
</style>
